<ul class="nav nav-tabs nav-justified border-bottom-0" role="tablist">
  @for(tab of tabs; track $index) {
  <li class="nav-item">
    <button
      class="nav-link"
      [ngClass]="{ active: activeTabIndex === $index }"
      (click)="toggleTab($index)"
      type="button"
      role="tab"
      [attr.aria-selected]="activeTabIndex === $index ? 'true' : 'false'"
    >
      <i [class]="tab.icon"></i> {{ tab.id | transloco }}
    </button>
  </li>
  }
</ul>

<div class="tab-content">
  @for(tab of tabs; track $index) {
  <div
    class="tab-pane fade mt-3"
    [ngClass]="{ 'show active': activeTabIndex === $index }"
    [id]="tab.id"
    role="tabpanel"
  >
    @switch(tab.id) { @case(TabEnum.program) {
    <div [innerHTML]="programDescription"></div>
    }@case(TabEnum.reviews) {
    <div>Content 3</div>
    }@case(TabEnum.about) {
    <div [innerHTML]="clinicDescription"></div>
    }@case(TabEnum.map) {
    <app-google-map-launcher
      [width]="'100%'"
      [height]="'300px'"
      [zoom]="17"
      [position]="maps"
    ></app-google-map-launcher>
    }@case(TabEnum.gallery) {
    <app-program-photos
      [clinicImages]="clinicImages"
      [teamImages]="teamImages"
    ></app-program-photos>
    } }
  </div>
  }
</div>
